<template>
  <div class="order-loading-mask" v-if="visible">
    <div class="folder-wrap">
      <div class="css-folder">
        <div class="folder-tab" :class="{ closed: isCompleted }"></div>
        <div class="folder-body">
          <div class="folder-label">空气虫档案夹</div>
          <div class="folder-lines">
            <div class="folder-line"></div>
            <div class="folder-line"></div>
            <div class="folder-line"></div>
          </div>
        </div>

        <!-- 动画文件 -->
        <div class="file file1" v-if="!isCompleted"></div>
        <div class="file file2" v-if="!isCompleted"></div>
        <div class="file file3" v-if="!isCompleted"></div>


        <!-- 完成动画 -->
        <div class="check" v-if="isCompleted">
          <svg class="check-circle" viewBox="0 0 52 52">
            <circle class="circle" cx="26" cy="26" r="24" fill="none" />
            <path class="checkmark" fill="none" d="M14 27l7 7 16-16" />
          </svg>
        </div>

      </div>
    </div>

    <!-- 动态文本：处理中/完成 -->
    <p class="loading-text">{{ isCompleted ? doneText : text }}</p>

    <!-- 进度条与百分比 -->
    <div class="progress-wrapper" v-if="showProgress">
      <div class="progress-container">
        <div
            class="progress-bar"
            :style="{ width: isCompleted ? '100%' : progressPercent + '%' }"
        ></div>
      </div>
      <div class="progress-percent">{{ isCompleted ? 100 : progressPercent }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingPage",
  props: {
    visible: Boolean,
    isCompleted: Boolean,
    text: {
      type: String,
      default: "正在处理，请稍后..."
    },
    doneText: {
      type: String,
      default: "处理完成！"
    },
    showProgress: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      progressPercent: 0,
      rafId: null
    };
  },
  watch: {
    isCompleted(newVal) {
      if (newVal) {
        this.progressPercent = 100;
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
        // 动画完成后回调
        setTimeout(() => this.$emit("animation-end"), 800);
      } else {
        this.progressPercent = 0;
        this.startProgressAnimation();
      }
    },
    visible(newVal) {
      if (!newVal) {
        this.progressPercent = 0;
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
      } else {
        if (!this.isCompleted) {
          this.startProgressAnimation();
        }
      }
    }
  },
  mounted() {
    if (!this.isCompleted && this.visible) {
      this.startProgressAnimation();
    }
  },
  beforeDestroy() {
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  },
  methods: {
    startProgressAnimation() {
      const step = () => {
        if (this.isCompleted || this.progressPercent >= 99) {
          this.progressPercent = 99;
          this.rafId = null;
          return;
        }
        this.progressPercent += 1;
        this.rafId = requestAnimationFrame(step);
      };
      if (!this.rafId) {
        this.rafId = requestAnimationFrame(step);
      }
    }
  }
};
</script>

<style scoped>
.order-loading-mask {
  position: fixed;
  inset: 0;
  background: rgba(248, 250, 252, 0.7);
  backdrop-filter: blur(1.5px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.folder-wrap {
  width: 220px;
  height: 150px;
  position: relative;
  margin-bottom: 20px;
  perspective: 1000px;
}

.css-folder {
  width: 100%;
  height: 100%;
  position: relative;
  animation: folder-in 0.3s ease-out;
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  border-radius: 4px 4px 0 0;
  box-shadow: 0 4px 12px rgba(30, 136, 229, 0.2);
  overflow: hidden;
  transform-style: preserve-3d;
  border: 1px solid rgba(144, 202, 249, 0.5);
}

.folder-tab {
  position: absolute;
  width: 90px;
  height: 16px;
  background: #64b5f6;
  top: -8px;
  left: 20px;
  border-radius: 6px 6px 0 0;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-origin: bottom;
  box-shadow: inset 0 -2px 4px rgba(0,0,0,0.1);
  z-index: 2;
  border: 1px solid rgba(100, 181, 246, 0.3);
  border-bottom: none;
}

.folder-tab.closed {
  transform: rotateX(-120deg) translateY(4px);
  opacity: 0.8;
  background: #42a5f5;
}

.folder-body {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 12px;
  background: linear-gradient(to bottom, #e3f2fd, #bbdefb);
  border: 1px solid rgba(144, 202, 249, 0.3);
  border-top: none;
}

.folder-label {
  font-size: 14px;
  color: #0d47a1;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 12px;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 6px;
  font-weight: 500;
  border: 1px solid rgba(13, 71, 161, 0.1);
}

.folder-lines {
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
}

.folder-line {
  height: 3px;
  background: rgba(30, 136, 229, 0.15);
  border-radius: 2px;
}

.folder-line:nth-child(1) { width: 100%; }
.folder-line:nth-child(2) { width: 90%; }
.folder-line:nth-child(3) { width: 80%; }

.file {
  position: absolute;
  width: 45px;
  height: 60px;
  background: white;
  border-radius: 3px;
  opacity: 0;
  animation: dropFile 0.8s ease infinite;
  box-shadow: 0 2px 6px rgba(30, 136, 229, 0.2);
  display: flex;
  flex-direction: column;
  padding: 4px;
  border: 1px solid #e3f2fd;
}
.file::before {
  content: "";
  height: 5px;
  background: #bbdefb;
  border-radius: 2px;
  margin-bottom: 3px;
}
.file::after {
  content: "";
  height: 3px;
  background: #bbdefb;
  border-radius: 2px;
  margin-top: 3px;
}
.file1 { top: -35px; left: 30px; animation-delay: 0s; transform: rotate(-5deg); }
.file2 { top: -35px; left: 90px; animation-delay: 0.6s; transform: rotate(2deg); }
.file3 { top: -35px; left: 150px; animation-delay: 1.2s; transform: rotate(5deg); }

@keyframes folder-in {
  from { transform: scale(0.95) translateY(10px); opacity: 0; }
  to { transform: scale(1) translateY(0); opacity: 1; }
}

@keyframes dropFile {
  0% { transform: translateY(0) rotate(0); opacity: 0; }
  40% { opacity: 1; }
  100% { transform: translateY(110px) rotate(5deg); opacity: 0; }
}

.check {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  z-index: 10;
}

.check-circle {
  width: 100%;
  height: 100%;
  stroke: #4CAF50;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

.circle {
  stroke-dasharray: 150;
  stroke-dashoffset: 150;
  animation: draw-circle 0.6s ease-out forwards;
}

.checkmark {
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: draw-check 0.4s ease-out 0.6s forwards;
}

@keyframes draw-circle {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes draw-check {
  to {
    stroke-dashoffset: 0;
  }
}

.loading-text {
  font-size: 15px;
  color: #1565c0;
  font-weight: 500;
  margin-top: 14px;
  letter-spacing: 0.3px;
}

.progress-wrapper {
  display: flex;
  align-items: center;
  margin-top: 16px;
  width: 250px;
}

.progress-container {
  flex-grow: 1;
  height: 4px;
  background: #e3f2fd;
  border-radius: 2px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  overflow: visible;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(to right, #1e88e5, #0d47a1);
  border-radius: 2px;
  transition: width 0.2s ease;
}

.progress-percent {
  margin-left: 10px;
  font-weight: 600;
  color: #000000;
  font-size: 14px;
  user-select: none;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// orderRecreatingLoading.vue?4a6c7685